const ENDPOINTS = {
  reservationPayments: (id: string) => `reservation-payments/?reservation=${id}`,
};

export {ENDPOINTS};
